<template>
  <div :key="refreshKey">
    <!-- 標題 begin -->
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-6">
          <h6 class="m-0 text-mcf-color">{{$t('mcfwallet.title')}}</h6>
        </div>
        <div class="col-6"></div>
      </div>
    </div>
    <!-- 標題 end -->
    <!-- tab begin -->
    <b-tabs
      class="te-tabs-mcf font-size-md position-relative px-3"
      nav-class=""
      justified
    >
      <template v-for="tab in tabs">
        <b-tab
          v-if="tab.isShow"
          :key="tab.type"
          :active="tab.type === currentTab"
          @click="onTabClick(tab.type)"
        >
          <template v-slot:title>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                align-items-center
                text-mcf-color
              "
            >
              <span>{{ tab.title }}</span>
              <h5 class="font-weight-normal m-0">
                {{ tab.walletQuantity }}
              </h5>
              <span class="active-bar bg-customize"></span>
            </div>
          </template>
        </b-tab>
      </template>
    </b-tabs>
    <!-- tab end -->
    <ListContainer
      :ref="'listcontainer'"
      itemKey="no"
      :fetch="fetch"
      :filter="filter"
      :emptyHint="emptyHint"
      :spinner="spinnerStyle"
      @reachBottom="showBottomHint = true"
    >
      <!-- List begin -->
      <template v-slot:list-item="{ item }">
        <McfWalletItem
          :mcfWalletItem="item"
          @gostore="gostore"
        />
      </template>
      <!-- List end -->
      <template v-slot:list-footer>
    <div v-if="showBottomHint" class="py-2 max-width m-3 text-center bg-gray200 font-size-sm">{{ footerwording }}</div>
      </template>
    </ListContainer>
    <McfWriteOffPc v-if="isWriteOffClick || isTransfer" />
  </div>
</template>

<script>
import { forkJoin } from 'rxjs';

import { mapState, mapActions, mapMutations } from 'vuex';
import ListContainer from '@/components/ListContainer.vue';
import McfWalletItem from '@/components/mcf/McfWalletItem.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

import McfWriteOffPc from '@/views/mcfwallet/McfWriteOffPc.vue';
import commonTool from '@/utils/commonTool';

export default {
  components: {
    McfWalletItem,
    ListContainer,
    McfWriteOffPc,
  },
  data() {
    return {
      title: '',
      // 頁籤資料
      tabs: [
        {
          type: 'usable',
          title: this.$t('mcfwallet.usable'),
          walletQuantity: 0,
          isShow: true,
        },
        {
          type: 'unused',
          title: this.$t('mcfwallet.unavailable'),
          walletQuantity: 0,
          isShow: true,
        },
      ],
      // 是否顯示底部文案
      showBottomHint: false,
      // 目前頁籤
      currentTab: 'usable',
      // 空白頁設定
      emptyHint: {},
      // 讀取spinner樣式
      spinnerStyle: '',
      filter: {
        status: undefined,
        source: 'TelexpressEC',
      },
      refreshKey: 0,

      wallets: [],
    };
  },
  created() {
    const vm = this;
    // 訂單篩選狀態，依照預設頁籤
    vm.filter.status = vm.currentTab;
    vm.$store.commit('set', { name: 'currentEticketTab', value: vm.currentTab });

    // 取得頁面 style
    vm.$store
      .dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.spinnerStyle = setting.layoutType === '0' ? 'light' : 'secondary';
        return setting;
      });

    vm.$store.dispatch('getPageSetting', 'ElectronicTicket')
      .then((setting) => {
        // 空白頁設定
        vm.emptyHint = {
          img: pageSettingGetter.getFunction(setting, 'BlankPagePic').picUrl,
          desc: this.$t('mcfwallet.noticketnow'),
        };
      });
    vm.getCompanyPermission().then((res) => {
      vm.setMemberSourceData({ id: 'companyName', value: res.response.data[0].companyName });
    });
    vm.setMemberSourceData({ id: 'isWriteOffClick', value: false });
    vm.setMemberSourceData({ id: 'isTransfer', value: false });
  },
  methods: {
    ...mapActions('memberSource', [
      'getCompanyPermission',
    ]),
    ...mapActions(['getEticketListCount', 'getEticketList', 'getStores',
    ]),
    ...mapMutations('memberSource', ['setMemberSourceData']),
    // 頁籤點擊
    onTabClick(type) {
      const vm = this;
      vm.showBottomHint = false;
      vm.currentTab = type;
      vm.filter.status = type;
      vm.$store.commit('set', {
        name: 'currentEticketTab',
        value: vm.currentTab,
      });
      // 設定空白頁文案
      if (vm.currentTab === 'usable') { vm.emptyHint.desc = this.$t('mcfwallet.noticketnow'); } else {
        vm.emptyHint.desc = this.$t('mcfwallet.noDatain3m');
      }
    },
    // 取得資料 observable
    fetch(pagination, filterlist) {
      const vm = this;
      const payload = { pagination, ...filterlist };
      return forkJoin({
        list: vm.updateEticketList(payload),
        updateTabs: vm.updateTabs(),
      });
    },
    // 更新頁籤資料
    updateTabs() {
      const vm = this;
      return vm.getEticketListCount().then((res) => {
        vm.tabs.forEach((tab) => {
          tab.walletQuantity = res.response.data[0][tab.type];
        });
      });
    },
    // 更新列表
    updateEticketList(payload) {
      const vm = this;
      return vm.getEticketList(payload).then((res) => {
        if (res.response && res.response.data) {
          this.wallets = res.response.data;
          return this.wallets;
        }
        return [];
      });
    },
    gostore() {
      commonTool.getPersonalStoreUrl().toPromise().then((url) => {
        window.location.assign(url);
      });
    },
  },
  computed: {
    ...mapState('memberSource', ['companyName']),
    ...mapState('memberSource', ['isWriteOffClick', 'isTransfer']),
    footerwording() {
      if (this.currentTab === 'usable') {
        return this.$t('mcfwallet.nomoreList');
      } return this.$t('notification.bottom-hint');
    },
  },
};
</script>
